export const NEW_ROUND_MODELER_TEST_IDS = {
  preMoney: 'new-round-modeler-pre-money',
  amountInvested: 'new-round-modeler-amount-invested',
  optionPoolRefresh: 'new-round-modeler-option-pool-refresh',
  fundInvestment: 'new-round-modeler-fund-investment',
  currentSharesOutstanding: 'new-round-modeler-current-shares-outstanding',
  premoneyUnallocatedOptions: 'new-round-modeler-premoney-unallocated-options',
  premoneyFullyDilutedShares: 'new-round-modeler-premoney-fully-diluted-shares',
  dilutionToExistingHolders: 'new-round-modeler-dilution-to-existing-holders',
  fundOwnershipPct: 'new-round-modeler-fund-ownership-pct',
} as const;
